export const COMPONENT_NAME = "kyb-documents";

export const DOCUMENT_SUCCESS_ICON = `<svg viewBox="0 0 24 24" width="18" height="18">
  <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/>
  <path d="M14 3v5h5"/>
  <path d="M9 14l2 2 4-4"/>
</svg>`;

export interface DocumentGroupItem {
  name: string;
  title: string;
  description: string;
  required?: boolean;
}

export interface DocumentGroup {
  id: string;
  title: string;
  documents: DocumentGroupItem[];
}

export const DOCUMENT_GROUPS: DocumentGroup[] = [
  {
    id: "registration",
    title: "Регистрация и учредительные документы",
    documents: [
      {
        name: "kyb-documents-registration-company",
        title: "Сертификат о регистрации компании",
        description:
          "Свидетельство о государственной регистрации, выданное регистрирующим органом",
      },
      {
        name: "kyb-documents-regulation",
        title: "Устав",
        description:
          "Действующая редакция со всеми страницами и отметкой регистрации",
        required: true,
      },
      {
        name: "kyb-documents-record-sheet",
        title: "Лист Записи",
        description: "Лист записи ЕГРЮЛ по последним изменениям",
      },
      {
        name: "kyb-documents-inn",
        title: "Свидетельство ИНН",
        description: "Свидетельство о постановке на учёт в налоговом органе",
        required: true,
      },
      {
        name: "kyb-documents-create",
        title: "Решение о создании / Учредительный договор",
        description:
          "Решение единственного участника или протокол собрания о создании",
        required: true,
      },
      {
        name: "kyb-documents-update",
        title: "Изменения в учредительные документы",
        description:
          "Протоколы и листы записи по всем изменениям. Если изменений не было — пропустите",
      },
    ],
  },
  {
    id: "structure",
    title: "Структура и полномочия",
    documents: [
      {
        name: "kyb-documents-list-of-shareholders",
        title: "Список акционеров",
        description: "Актуальный список участников с размерами долей",
      },
      {
        name: "kyb-documents-purpose",
        title: "О назначении единоличного исполнительного органа",
        description:
          "Решение или приказ о назначении директора с указанием срока полномочий",
        required: true,
      },
      {
        name: "kyb-documents-example",
        title: "Карточка образцов подписей и печатей",
        description:
          "Банковская карточка с образцами подписей уполномоченных лиц",
        required: true,
      },
      {
        name: "kyb-documents-license",
        title: "Лицензия",
        description:
          "Если деятельность лицензируется — лицензия со всеми приложениями",
      },
    ],
  },
  {
    id: "finance",
    title: "Адрес и финансы",
    documents: [
      {
        name: "kyb-documents-check-addresses",
        title: "Подтверждение адреса регистрации",
        description:
          "Договор аренды, свидетельство о собственности или письмо от арендодателя",
        required: true,
      },
      {
        name: "kyb-documents-finance",
        title: "Финансовая отчетность (за год/за квартал)",
        description:
          "Баланс и отчёт о финансовых результатах за последний период",
        required: true,
      },
      {
        name: "kyb-documents-sow",
        title: "Доказательства источника дохода SoW",
        description:
          "Документы, подтверждающие происхождение благосостояния компании",
      },
      {
        name: "kyb-documents-sof",
        title: "Доказательства источника средств SoF",
        description:
          "Документы по средствам, которые вы планируете вводить: договоры, выписки, счета",
      },
    ],
  },
];
